(function () {
  'use strict';

  /* Sticky header — the theme's <body> is a CSS grid, which defeats position:sticky on
     the nav (it un-sticks immediately). Pin it with position:fixed once the page scrolls
     past the nav's natural position (i.e. the announcement bar has scrolled away), and
     pad #MainContent by the nav height so the content doesn't jump. */
  function initStickyNav() {
    var nav = document.querySelector('.navbar');
    if (!nav) return;
    var main = document.getElementById('MainContent');
    var stuck = false;
    var threshold = 0;

    function measure() {
      var wasStuck = nav.classList.contains('is-stuck');
      if (wasStuck) nav.classList.remove('is-stuck');
      threshold = nav.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
      if (wasStuck) nav.classList.add('is-stuck');
    }

    function onScroll() {
      var y = window.scrollY || window.pageYOffset || 0;
      if (y >= threshold && !stuck) {
        stuck = true;
        nav.classList.add('is-stuck', 'scrolled');
        if (main) main.style.paddingTop = nav.offsetHeight + 'px';
      } else if (y < threshold && stuck) {
        stuck = false;
        nav.classList.remove('is-stuck', 'scrolled');
        if (main) main.style.paddingTop = '';
      }
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (main && stuck) main.style.paddingTop = nav.offsetHeight + 'px';
      measure();
      onScroll();
    });
    onScroll();
  }

  /* Back-to-top button — appears after scrolling down, smooth-scrolls to top. */
  function initBackToTop() {
    if (document.querySelector('.laku-back-to-top')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'laku-back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' +
      '<path d="M12 5l-7 7h4v7h6v-7h4z" fill="currentColor"/></svg>';
    document.body.appendChild(btn);
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    function onScroll() {
      var y = window.scrollY || window.pageYOffset || 0;
      btn.classList.toggle('is-visible', y > 600);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    initStickyNav();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
